import { type ReactNode, type RefObject } from 'react';

interface DashboardContentProps {
  children: ReactNode;
  mainRef?: RefObject<HTMLElement>;
}

/**
 * Main content column. This is the *only* element that scrolls — the window
 * height is fixed via the layout shell, so route content, sticky headers,
 * and modals can rely on a stable viewport.
 */
export function DashboardContent({ children, mainRef }: DashboardContentProps) {
  return (
    <main
      ref={mainRef}
      id="tankef-content"
      className="flex min-w-0 flex-1 flex-col overflow-y-auto"
    >
      {children}
    </main>
  );
}
